import { render, staticRenderFns } from "./BaseReportTable.vue?vue&type=template&id=a629003c&scoped=true"
import script from "./BaseReportTable.vue?vue&type=script&lang=js"
export * from "./BaseReportTable.vue?vue&type=script&lang=js"
import style0 from "./BaseReportTable.vue?vue&type=style&index=0&id=a629003c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a629003c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
